var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("q-form", { ref: "editForm" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _vm.popupParam.userManualId
            ? _c("c-card", {
                staticClass: "cardClassDetailForm revisionLayout",
                attrs: { title: "개정", topClass: "topcolor-orange" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "card-detail",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-2" },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        required:
                                          _vm.editable && _vm.isRevision,
                                        editable:
                                          _vm.editable && _vm.isRevision,
                                        label: "개정번호",
                                        name: "revisionNum",
                                      },
                                      model: {
                                        value: _vm.userManual.revisionNum,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.userManual,
                                            "revisionNum",
                                            $$v
                                          )
                                        },
                                        expression: "userManual.revisionNum",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-2" },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        editable: false,
                                        label: "개정일시",
                                        name: "regDtStr",
                                      },
                                      model: {
                                        value: _vm.userManual.regDtStr,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.userManual,
                                            "regDtStr",
                                            $$v
                                          )
                                        },
                                        expression: "userManual.regDtStr",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-2" },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        editable: false,
                                        label: "개정자",
                                        name: "regUserName",
                                      },
                                      model: {
                                        value: _vm.userManual.regUserName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.userManual,
                                            "regUserName",
                                            $$v
                                          )
                                        },
                                        expression: "userManual.regUserName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-6" },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        required:
                                          _vm.editable && _vm.isRevision,
                                        editable:
                                          _vm.editable && _vm.isRevision,
                                        label: "개정사유",
                                        name: "revisionContent",
                                      },
                                      model: {
                                        value: _vm.userManual.revisionContent,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.userManual,
                                            "revisionContent",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "userManual.revisionContent",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  954139603
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c("c-card", {
            staticClass: "cardClassDetailForm",
            attrs: { title: "사용자매뉴얼 기본정보" },
            scopedSlots: _vm._u([
              {
                key: "card-select",
                fn: function () {
                  return [
                    _vm.popupParam.userManualId
                      ? _c("c-select", {
                          attrs: {
                            editable: !_vm.isRevision,
                            comboItems: _vm.gridrev.data,
                            type: "custom",
                            typetext: "개정이력",
                            itemText: "revisionNum",
                            itemValue: "userManualId",
                            name: "selectedUserManualId",
                            label: "",
                          },
                          on: { datachange: _vm.rowClickRev },
                          model: {
                            value: _vm.selectedUserManualId,
                            callback: function ($$v) {
                              _vm.selectedUserManualId = $$v
                            },
                            expression: "selectedUserManualId",
                          },
                        })
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "card-button",
                fn: function () {
                  return [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _c("c-btn", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.editable &&
                                _vm.popupParam.userManualId &&
                                !_vm.isRevision,
                              expression:
                                "editable && popupParam.userManualId && !isRevision",
                            },
                          ],
                          attrs: { label: "개정", icon: "restart_alt" },
                          on: { btnClicked: _vm.setRevision },
                        }),
                        _c("c-btn", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.editable &&
                                _vm.popupParam.userManualId &&
                                _vm.isRevision,
                              expression:
                                "editable && popupParam.userManualId && isRevision",
                            },
                          ],
                          attrs: { label: "개정취소", icon: "restart_alt" },
                          on: { btnClicked: _vm.cancelRevision },
                        }),
                        _vm.editable && _vm.popupParam.userManualId
                          ? _c("c-btn", {
                              attrs: { label: "삭제", icon: "remove" },
                              on: { btnClicked: _vm.deleteData },
                            })
                          : _vm._e(),
                        _vm.editable
                          ? _c("c-btn", {
                              attrs: {
                                url: _vm.saveUrl,
                                isSubmit: _vm.isSave,
                                param: _vm.userManual,
                                mappingType: _vm.mappingType,
                                label: "저장",
                                icon: "save",
                              },
                              on: {
                                beforeAction: _vm.saveData,
                                btnCallback: _vm.saveCallback,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "card-detail",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: false,
                            label: "문서일련번호",
                            name: "userManualId",
                          },
                          model: {
                            value: _vm.userManual.userManualId,
                            callback: function ($$v) {
                              _vm.$set(_vm.userManual, "userManualId", $$v)
                            },
                            expression: "userManual.userManualId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            required: true,
                            editable: _vm.editable,
                            label: "업무명",
                            name: "taskName",
                          },
                          model: {
                            value: _vm.userManual.taskName,
                            callback: function ($$v) {
                              _vm.$set(_vm.userManual, "taskName", $$v)
                            },
                            expression: "userManual.taskName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("c-textarea", {
                          attrs: {
                            editable: _vm.editable,
                            label: "업무개요",
                            name: "taskSummary",
                            autogrow: "",
                          },
                          model: {
                            value: _vm.userManual.taskSummary,
                            callback: function ($$v) {
                              _vm.$set(_vm.userManual, "taskSummary", $$v)
                            },
                            expression: "userManual.taskSummary",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
          staticStyle: { "padding-top": "20px !important" },
        },
        [
          _c("c-upload", {
            attrs: {
              attachInfo: _vm.attachInfo,
              editable: _vm.editable,
              label: "사용자매뉴얼 첨부파일",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }